document.addEventListener("DOMContentLoaded", function () {
  const sectionId = window.productSectionId;
  if (!sectionId) return;

  window.initAccordionSection(sectionId);

  const productData = window.productData;
  const currentVariant = window.currentVariant;
  if (!productData || !currentVariant) return;

  const productForm = document.querySelector(".form");
  if (!productForm) return;

  // Slider elements
  const customSlider = document.getElementById("product-gallery-slider");
  const slider = document.getElementById("media-slider");
  if (!slider) return;

  const slides = Array.from(
    document.querySelectorAll(".media-wrapper[data-slider-item]")
  );
  const totalSlides = slides.length;
  const galleryThumbs = document.querySelector(".gallery-thumbs");
  const thumbsRing = document.querySelector(".thumbs-ring");
  const prevBtn = document.querySelector(".gallery-arrow--prev");
  const nextBtn = document.querySelector(".gallery-arrow--next");
  const mobileCount = document.querySelector(".current-position");

  let currentIndex = 0;

  // ---------- Helpers ----------
  function isDesktop() {
    return window.innerWidth >= 1000;
  }

  function calculateTranslateForIndex(index) {
    // Desktop: each slide is 50%
    return -(index * (slider.offsetWidth * 0.5));
  }

  function setSliderTransform(x, instant = false) {
    if (instant) {
      slider.style.transition = "none";
    } else {
      slider.style.transition = "transform 0.3s ease";
    }
    slider.style.transform = `translateX(${x}px)`;
  }

  function updateFileUploadVisibility(variant) {
    const uploadWrapper = document.querySelector(".product-file-upload");
    if (!uploadWrapper || !variant || !productData.options) return;

    // Find index of "Power" option (case-insensitive)
    const powerOptionIndex = productData.options.findIndex(
      (opt) => opt.toLowerCase() === "power"
    );

    // If product has no Power option → always show upload
    if (powerOptionIndex === -1) {
      uploadWrapper.style.display = "";
      return;
    }

    const selectedPowerValue = variant.options[powerOptionIndex];

    if (
      selectedPowerValue &&
      selectedPowerValue.trim().toUpperCase() === "NO POWER (PLANO)"
    ) {
      uploadWrapper.style.display = "none";
    } else {
      uploadWrapper.style.display = "";
    }
  }

  function clampIndex(i) {
    // Desktop: max index allows 2 slides visible
    const maxIndex = Math.max(0, totalSlides - 2);
    return Math.max(0, Math.min(i, maxIndex));
  }

  // ---------- Desktop Only: Navigation ----------
  function goToIndex(index) {
    if (!isDesktop()) return; // Mobile handled by CustomSlider
    currentIndex = clampIndex(index);
    const x = calculateTranslateForIndex(currentIndex);
    setSliderTransform(x);
    updateThumbsRing();
    handleVideoPlayback(currentIndex);
  }

  // ---------- Desktop Only: Thumbnails ----------
  function buildThumbnails() {
    if (!galleryThumbs || !isDesktop()) return;
    galleryThumbs.innerHTML = "";
    window._productThumbs = [];

    slides.forEach((slide, idx) => {
      const thumbBtn = document.createElement("button");
      thumbBtn.setAttribute("type", "button");
      thumbBtn.setAttribute("aria-label", `Show image ${idx + 1}`);
      thumbBtn.dataset.index = idx;
      thumbBtn.classList.add("gallery-thumb-btn");

      const img = slide.querySelector("img");
      if (img) {
        const small = document.createElement("img");
        small.classList.add("thumbnail-img");
        small.src = img.src;
        small.alt = img.alt || "";
        thumbBtn.appendChild(small);
      } else {
        thumbBtn.textContent = idx + 1;
      }

      thumbBtn.addEventListener("click", () => {
        goToIndex(idx);
      });
      galleryThumbs.appendChild(thumbBtn);
      window._productThumbs.push(thumbBtn);
    });

    if (thumbsRing) {
      thumbsRing.style.left = "0px";
      thumbsRing.style.width = "0px";
    }
    updateThumbsRing();
  }

  function updateThumbsRing() {
    if (!thumbsRing || !galleryThumbs || !window._productThumbs || !isDesktop())
      return;
    const thumbs = window._productThumbs;
    const total = thumbs.length;
    const count = 2;
    let startThumb = currentIndex;

    if (startThumb < 0) startThumb = 0;
    if (startThumb + count > total) startThumb = total - count;

    const firstThumbEl = thumbs[startThumb];
    const lastThumbEl = thumbs[startThumb + count - 1];

    if (!firstThumbEl || !lastThumbEl) {
      thumbsRing.style.width = "0px";
      thumbs.forEach((btn) => btn.classList.remove("active"));
      return;
    }

    const containerRect = galleryThumbs.getBoundingClientRect();
    const firstRect = firstThumbEl.getBoundingClientRect();
    const lastRect = lastThumbEl.getBoundingClientRect();

    const left = firstRect.left - containerRect.left + galleryThumbs.scrollLeft;
    const right =
      lastRect.right - containerRect.left + galleryThumbs.scrollLeft;
    const width = Math.max(2, right - left);

    thumbsRing.style.width = `${width}px`;
    thumbsRing.style.transform = `translateX(${left}px)`;

    thumbs.forEach((btn, idx) => {
      const isActive = idx >= startThumb && idx < startThumb + count;
      btn.classList.toggle("active", isActive);
    });

    const midIndex = startThumb + Math.floor((count - 1) / 2);
    const midThumb = thumbs[midIndex];
    if (midThumb && typeof midThumb.scrollIntoView === "function") {
      midThumb.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }

  // ---------- Arrows (Desktop only) ----------
  function hideArrowsOnMobile() {
    if (!isDesktop()) {
      if (prevBtn) prevBtn.style.display = "none";
      if (nextBtn) nextBtn.style.display = "none";
    } else {
      if (prevBtn) prevBtn.style.display = "";
      if (nextBtn) nextBtn.style.display = "";
    }
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      if (!isDesktop() || totalSlides <= 3) return;
      goToIndex(currentIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      if (!isDesktop() || totalSlides <= 3) return;
      goToIndex(currentIndex + 1);
    });
  }

  // ---------- Mobile Counter Update ----------
  function updateMobileCounter() {
    if (!isDesktop() && mobileCount && customSlider) {
      // Get current index from CustomSlider bullets
      const bulletsContainer = document.querySelector(
        `[data-bullets-id="product-gallery-bullets-${sectionId}"]`
      );
      if (bulletsContainer) {
        const activeBullet = bulletsContainer.querySelector(
          ".slider-bullet.active"
        );
        if (activeBullet) {
          const slideIndex = parseInt(
            activeBullet.getAttribute("data-slide-index") || "0",
            10
          );
          mobileCount.textContent = slideIndex + 1;
        }
      }
    }
  }

  // Monitor CustomSlider bullet changes for mobile counter
  const bulletsContainer = document.querySelector(
    `[data-bullets-id="product-gallery-bullets-${sectionId}"]`
  );
  if (bulletsContainer && mobileCount) {
    const observer = new MutationObserver(() => {
      updateMobileCounter();
    });
    observer.observe(bulletsContainer, {
      attributes: true,
      attributeFilter: ["class"],
      subtree: true,
    });
    // Initial update
    updateMobileCounter();
  }

  // ---------- Desktop Only: Dragging ----------
  function setupDesktopDragging() {
    if (!isDesktop() || totalSlides <= 3) return;

    let isDragging = false;
    let startPos = 0;
    let prevTranslate = 0;

    function pointerDown(clientX) {
      isDragging = true;
      startPos = clientX;
      slider.style.transition = "none";
      prevTranslate = calculateTranslateForIndex(currentIndex);
    }

    function pointerMove(clientX) {
      if (!isDragging) return;
      const diff = clientX - startPos;
      const nextTranslate = prevTranslate + diff;
      slider.style.transform = `translateX(${nextTranslate}px)`;
    }

    function pointerUp() {
      if (!isDragging) return;
      isDragging = false;

      const moved = slider.style.transform.match(/-?\d+/)
        ? parseFloat(slider.style.transform.match(/-?\d+/)[0]) - prevTranslate
        : 0;
      const threshold = slider.offsetWidth * 0.25;

      if (moved < -threshold && currentIndex < totalSlides - 2) {
        goToIndex(currentIndex + 1);
      } else if (moved > threshold && currentIndex > 0) {
        goToIndex(currentIndex - 1);
      } else {
        setSliderTransform(prevTranslate);
      }
    }

    slider.addEventListener("mousedown", (e) => {
      e.preventDefault();
      pointerDown(e.clientX);
      const moveHandler = (ev) => pointerMove(ev.clientX);
      const upHandler = () => {
        pointerUp();
        window.removeEventListener("mousemove", moveHandler);
        window.removeEventListener("mouseup", upHandler);
      };
      window.addEventListener("mousemove", moveHandler);
      window.addEventListener("mouseup", upHandler);
    });
  }

  // ---------- VIDEO ----------
  const videos = document.querySelectorAll(".product-page .main-video");

  document
    .querySelectorAll(".media-wrapper img, .media-wrapper video")
    .forEach((el) => {
      el.addEventListener("dragstart", (e) => e.preventDefault());
    });

  function initializeVideos() {
    videos.forEach((video) => {
      video.currentTime = 0.1;
      video.pause();
      video.loop = true;
      video.muted = true;
      video.pauseInline = true;
    });
  }

  let observer;
  function setupMobileVideoBehavior() {
    if (isDesktop()) return; // Only on mobile
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector("video");
          if (!video) return;
          if (entry.isIntersecting) {
            video.play().catch(() => {
              const container = video.closest(".video-container");
              if (container) container.classList.add("autoplay-failed");
            });
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.7, rootMargin: "0px" }
    );
    slides.forEach((slide) => observer.observe(slide));
    document
      .querySelectorAll(".video-container.autoplay-failed")
      .forEach((container) => {
        container.addEventListener("click", function () {
          const video = this.querySelector("video");
          if (video.paused) {
            video.play();
            this.classList.remove("autoplay-failed");
          }
        });
      });
  }

  function handleVideoPlayback(index) {
    if (!isDesktop()) return; // Video handling on mobile is done via IntersectionObserver
    videos.forEach((video, i) => {
      const container = video.closest(".video-container");
      if (i === index) {
        video.play().catch(() => {});
        container.classList.add("play");
      } else {
        video.pause();
        container.classList.remove("play");
      }
    });
  }

  // ---------- Initialize ----------
  function setSliderSize() {
    if (isDesktop() && totalSlides > 3) {
      const moveBy = calculateTranslateForIndex(currentIndex);
      setSliderTransform(moveBy, true);
      updateThumbsRing();
    }
  }

  // Initialize
  hideArrowsOnMobile();
  if (isDesktop()) {
    buildThumbnails();
    setSliderSize();
    setupDesktopDragging();
  }
  initializeVideos();
  if (!isDesktop()) {
    setupMobileVideoBehavior();
  }

  window.addEventListener("resize", () => {
    hideArrowsOnMobile();
    if (isDesktop()) {
      setSliderSize();
      buildThumbnails();
      updateThumbsRing();
    } else {
      updateMobileCounter();
    }
  });

  // Expose API for other scripts
  window.productGallery = {
    goToIndex,
  };

  // VARIANT HANDLING
  const radios = document.querySelectorAll(
    '.variant-selector input[type="radio"]'
  );
  const buyNowBtn = document.querySelector(".buy-now-btn");

  // Auto-select first available if only 1 option
  if (productData.options.length === 1) {
    const firstAvailable = productData.variants.find((v) => v.available);
    if (firstAvailable) {
      updateVariant(firstAvailable);
      document.querySelectorAll(".variant-option input").forEach((input) => {
        const isAvailable = productData.variants.some(
          (v) => v.available && v.options[0] === input.value
        );
        !isAvailable
          ? input.classList.add("disabled")
          : input.classList.remove("disabled");

        if (firstAvailable.options[0] === input.value) input.checked = true;
      });
    }
  }

  radios.forEach((radio) => {
    radio.addEventListener("change", function () {
      const selectedOptions = getSelectedOptions();
      const selectedVariant = findVariantByOptions(selectedOptions);
      if (selectedVariant) updateVariant(selectedVariant);
      updateOptionAvailability(selectedOptions);
    });
  });

  function updateOptionAvailability(selectedOptions) {
    productData.options.forEach((optionName, optionIndex) => {
      const groupInputs = document.querySelectorAll(
        `.variant-option:nth-child(${optionIndex + 1}) input`
      );
      groupInputs.forEach((input) => {
        const isPossible = productData.variants.some((variant) => {
          if (!variant.available) return false;
          return variant.options.every((opt, idx) => {
            if (idx === optionIndex) return opt === input.value;
            return !selectedOptions[idx] || selectedOptions[idx] === opt;
          });
        });
        !isPossible
          ? input.classList.add("disabled")
          : input.classList.remove("disabled");
      });
    });
  }

  function getSelectedOptions() {
    const selectedOptions = [];
    document.querySelectorAll(".variant-option").forEach((group) => {
      const checked = group.querySelector('input[type="radio"]:checked');
      const labels = group.querySelectorAll(".option-value");
      labels.forEach((label) => label.classList.remove("selected"));
      if (checked) {
        selectedOptions.push(checked.value);
        const checkedLabel = group.querySelector(`label[for="${checked.id}"]`);
        if (checkedLabel) checkedLabel.classList.add("selected");
      } else {
        selectedOptions.push(null);
      }
    });
    return selectedOptions;
  }

  function findVariantByOptions(options) {
    return productData.variants.find((variant) => {
      return variant.options.every(
        (opt, idx) => !options[idx] || options[idx] === opt
      );
    });
  }

  function updateVariant(variant) {
    window.history.replaceState(null, null, `?variant=${variant.id}`);
    productForm.querySelector('[name="id"]').value = variant.id;
    updatePrices(variant);
    updateAvailability(variant);

    // 👇 Fix image handling
    const firstImageEl = document.querySelector(".variant-dynamic-image");
    if (firstImageEl) {
      if (variant.featured_media) {
        firstImageEl.src = variant.featured_media.preview_image.src;
        firstImageEl.alt = variant.featured_media.alt || "";
      } else if (productData.featured_media) {
        firstImageEl.src = productData.featured_media.preview_image.src;
        firstImageEl.alt = productData.featured_media.alt || "";
      }
    }
    updateFileUploadVisibility(variant);
  }

  function updatePrices(variant) {
    const currentPrice = document.querySelector(".current-price");
    const comparePrice = document.querySelector(".compare-price");
    const savings = document.querySelector(".savings");
    if (!currentPrice || !comparePrice) return;
    currentPrice.textContent = Shopify.formatMoney(
      variant.price,
      window.money_without_trailing_zeros_format
    );
    if (variant.compare_at_price > variant.price) {
      comparePrice.textContent = Shopify.formatMoney(
        variant.compare_at_price,
        window.money_without_trailing_zeros_format
      );
      const saveValue = 100 - (variant.price / variant.compare_at_price) * 100;
      savings.textContent = `${Math.round(saveValue)}% SAVED`;
      comparePrice.style.display = "inline";
      savings.style.display = "inline";
    } else {
      comparePrice.style.display = "none";
      savings.style.display = "none";
    }
  }

  function updateAvailability(variant) {
    const addToCartBtn = document.querySelector(
      ".product-page .add-to-cart-btn"
    );
    const quantitySelector = document.querySelector(".quantity-selector");
    const selectedValueElements = document.querySelectorAll(".selected-value");
    if (variant && variant.options) {
      variant.options.forEach((opt, idx) => {
        if (selectedValueElements[idx]) {
          selectedValueElements[idx].textContent = opt;
        }
      });
    }
    if (variant.available) {
      quantitySelector.style.display = "flex";
      addToCartBtn.innerHTML = `${
        window.bagSvg
          ? `<span class="svg_wrapper-small">${window.bagSvg}</span>`
          : ""
      }Add To Bag`;
      addToCartBtn.disabled = false;
      buyNowBtn.disabled = false;
    } else {
      quantitySelector.style.display = "none";
      addToCartBtn.disabled = true;
      buyNowBtn.disabled = true;
      addToCartBtn.textContent = window.soldOutText || "Sold Out";
    }
  }

  function checkUrlVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");
    if (variantId) {
      const variant = productData.variants.find((v) => v.id == variantId);
      if (variant) updateVariant(variant);
    } else {
      updateVariant(currentVariant);
    }
    updateOptionAvailability(getSelectedOptions());
  }

  // Form submission
  productForm.addEventListener("submit", async function (e) {
    e.preventDefault();
    const formData = new FormData(productForm);
    const submitBtn = productForm.querySelector('[type="submit"]');
    const originalText = submitBtn.innerHTML;
    submitBtn.disabled = true;
    submitBtn.textContent = window.addingText || "Adding...";

    try {
      // Get checked upsell products
      const checkedUpsells = document.querySelectorAll(
        '.product-upsell-form input[type="checkbox"]:checked'
      );
      const upsellItems = Array.from(checkedUpsells).map((checkbox) => ({
        id: parseInt(checkbox.value),
        quantity: 1,
      }));

      // Clear cart first
      await fetch("/cart/clear.js", { method: "POST" });

      // Add main product with file (FormData includes file automatically if present)
      const mainProductFormData = new FormData();
      mainProductFormData.append("id", formData.get("id"));
      mainProductFormData.append("quantity", formData.get("quantity") || "1");

      // Add file if present
      const fileInput = document.getElementById(
        `proof-of-payment-${sectionId}`
      );
      if (fileInput && fileInput.files.length > 0) {
        mainProductFormData.append(
          "properties[Proof of Payment]",
          fileInput.files[0]
        );
      }

      await fetch("/cart/add.js", {
        method: "POST",
        body: mainProductFormData,
      });

      // Add upsell products using JSON API
      if (upsellItems.length > 0) {
        const items = upsellItems.map((item) => ({
          id: item.id,
          quantity: item.quantity,
        }));

        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items }),
        });
      }

      // Get updated cart
      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();

      publish(PUB_SUB_EVENTS.cartUpdate, {
        action: "add",
        variant: cartData,
        formData: Object.fromEntries(formData),
        product: productData,
      });
    } catch (error) {
      console.error("Error:", error);
      publish(PUB_SUB_EVENTS.cartError, {
        error: error.message,
        context: "add-to-cart",
        productId: productData.id,
      });
    } finally {
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalText;
    }
  });

  if (buyNowBtn) {
    buyNowBtn.addEventListener("click", (e) => {
      try {
        buyNowBtn.classList.add("loading");
        const productForm = e.target.closest(".product-form");
        const checkoutForm = document.createElement("form");
        checkoutForm.method = "POST";
        checkoutForm.action = "/cart/add";

        // Add main product
        const mainProductInput = document.createElement("input");
        mainProductInput.type = "hidden";
        mainProductInput.name = `id`;
        mainProductInput.value = productForm.querySelector('[name="id"]').value;
        checkoutForm.appendChild(mainProductInput);

        const mainProductQty = document.createElement("input");
        mainProductQty.type = "hidden";
        mainProductQty.name = `quantity`;
        mainProductQty.value =
          document.querySelector('[name="quantity"]').value;
        checkoutForm.appendChild(mainProductQty);

        const returnToInput = document.createElement("input");
        returnToInput.type = "hidden";
        returnToInput.name = "return_to";
        returnToInput.value = "/checkout";
        checkoutForm.appendChild(returnToInput);

        document.body.appendChild(checkoutForm);
        checkoutForm.submit();
      } catch (error) {
        console.log(error);
      } finally {
        setTimeout(() => {
          buyNowBtn.classList.remove("loading");
        }, 300);
      }
    });
  }

  checkUrlVariant();

  // FILE UPLOAD HANDLING
  const fileInput = document.getElementById(`proof-of-payment-${sectionId}`);
  const fileContainer = document.getElementById(
    `file-upload-container-${sectionId}`
  );
  const fileButton = document.getElementById(`file-upload-button-${sectionId}`);
  const filePreview = document.getElementById(`file-preview-${sectionId}`);
  const previewImage = document.getElementById(`preview-image-${sectionId}`);
  const fileRemove = document.getElementById(`file-remove-${sectionId}`);
  const fileError = document.getElementById(`file-error-${sectionId}`);

  if (
    fileInput &&
    fileContainer &&
    fileButton &&
    filePreview &&
    previewImage &&
    fileRemove &&
    fileError
  ) {
    function validateFile(file) {
      if (!file) return false;
      if (!file.type.match("image.*")) {
        fileError.textContent = "Please upload an image file.";
        fileError.classList.add("show");
        return false;
      }
      fileError.classList.remove("show");
      return true;
    }

    function handleFile(file) {
      if (!validateFile(file)) {
        fileInput.value = "";
        return;
      }

      const reader = new FileReader();
      reader.onload = function (e) {
        previewImage.src = e.target.result;
        fileContainer.classList.add("has-image");
      };
      reader.readAsDataURL(file);
    }

    function clearFile() {
      fileInput.value = "";
      previewImage.src = "";
      fileContainer.classList.remove("has-image");
      fileError.classList.remove("show");
    }

    // Click to upload
    fileButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      fileInput.click();
    });

    fileContainer.addEventListener("click", (e) => {
      if (
        !fileContainer.classList.contains("has-image") &&
        e.target !== fileInput
      ) {
        fileInput.click();
      }
    });

    // File input change
    fileInput.addEventListener("change", (e) => {
      if (e.target.files.length > 0) {
        handleFile(e.target.files[0]);
      }
    });

    // Remove file
    fileRemove.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      clearFile();
    });

    // Drag and drop
    ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
      fileContainer.addEventListener(eventName, (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    fileContainer.addEventListener("dragenter", () => {
      fileContainer.classList.add("drag-over");
    });

    fileContainer.addEventListener("dragleave", () => {
      fileContainer.classList.remove("drag-over");
    });

    fileContainer.addEventListener("drop", (e) => {
      fileContainer.classList.remove("drag-over");
      if (e.dataTransfer.files.length > 0) {
        const file = e.dataTransfer.files[0];
        fileInput.files = e.dataTransfer.files;
        handleFile(file);
      }
    });

    // Prevent default drag behavior on window
    ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
      window.addEventListener(
        eventName,
        (e) => {
          e.preventDefault();
          e.stopPropagation();
        },
        false
      );
    });
  }

  // SIZE CHART
  const sizeBtn = document.querySelector("[data-open-table]");
  const sizePopup = document.querySelector(".size-chart-popup");
  const sizePopupContent = sizePopup
    ? sizePopup.querySelector(".size-chart-content")
    : null;
  const sizeClosePopup = sizePopup
    ? sizePopup.querySelector(".size-chart-close")
    : null;
  let isOpening = true;
  const toggleSizeChart = () => {
    if (isOpening) {
      document.body.style.overflow = "hidden";
      sizePopup.classList.add("open");
      isOpening = false;
    } else {
      document.body.style.overflow = "";
      sizePopup.classList.remove("open");
      isOpening = true;
    }
  };
  if (sizeBtn && sizePopup) {
    sizeBtn.addEventListener("click", toggleSizeChart);
    sizePopup.addEventListener("click", (e) => {
      if (
        !sizePopupContent.contains(e.target) &&
        sizePopupContent !== e.target &&
        !isOpening
      ) {
        toggleSizeChart();
      }
    });
  }
  if (sizeClosePopup) {
    sizeClosePopup.addEventListener("click", toggleSizeChart);
  }
  document.addEventListener("keydown", (e) => {
    if (
      e.key === "Escape" &&
      !isOpening &&
      sizePopup &&
      sizePopup.classList.contains("open")
    )
      toggleSizeChart();
  });
});
